import { FormValidationFunction } from '@/views/interfaces/vuetify/form.interface';

export class EditTagForm {
  public color: string = '';
  public label: string = '';

  public rules: { [key: string]: FormValidationFunction[] } = {
    color: [
      (v: string) => !!v || 'Color is required',
      (v: string) => v.length !== 9 || 'Color has to be 9 characters',
    ],
    label: [
      (v: string) => !!v || 'Label is required',
      (v: string) => v.length >= 3 || 'Label has to be at least 3 characters',
    ],
  };
}
